import React, { useState } from "react";
import { useCategoryFolders } from "../hooks/useCategoryFolders";
import BreadcrumbNavigation from "./BreadcrumbNavigation";
import RootFolder from "./RootFolder";
import FolderView from "./FolderView";

export default function CategoryFolderList({ departmentId }) {
  const { data: folders, isLoading, error } = useCategoryFolders(departmentId);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);

  const handleFolderSelect = (folder) => {
    setSelectedFolder(folder);
    setBreadcrumb((prev) => [...prev, folder]);
  };

  const handleBreadcrumbClick = (index) => {
    if (index === breadcrumb.length) return; // current folder
    if (index === 0) {
      // Clicked root breadcrumb
      setBreadcrumb([]);
      setSelectedFolder(null);
      return;
    }
    const newBreadcrumb = breadcrumb.slice(0, index);
    setBreadcrumb(newBreadcrumb);
    setSelectedFolder(newBreadcrumb[newBreadcrumb.length - 1] || null);
  };

  const breadcrumbItems = [
    { key: "root", label: "Root", show: true },
    ...breadcrumb.map((folder) => ({
      key: folder.folderId,
      label: folder.folderName,
      show: true,
    })),
  ];

  if (isLoading) return <div>Loading folders...</div>;
  if (error) return <div>Error loading folders</div>;

  return (
    <div>
      <BreadcrumbNavigation
        breadcrumbItems={breadcrumbItems}
        activeIndex={breadcrumb.length}
        onBreadcrumbClick={handleBreadcrumbClick}
      />

      {!selectedFolder ? (
        <RootFolder
          folders={folders}
          onFolderSelect={handleFolderSelect}
          departmentId={departmentId}
        />
      ) : (
        <FolderView
          folder={selectedFolder}
          onFolderSelect={handleFolderSelect}
          onFolderUpdate={(updatedFolder) => {
            setSelectedFolder(updatedFolder);
          }}
        />
      )}
    </div>
  );
}
